import React, { useEffect, useRef, useState, useContext } from "react";

import styled from "styled-components";
import { io } from 'socket.io-client';
import { useParams } from "react-router";
import { Bars } from "react-loader-spinner";

import Web2BidComponents from '../../BidComponents/Web2BidComponents';

import { getLoginInformation,
         getPaymentInformation
} from '../../../utils/loginHelper';
import {sendIndiaBidToBackend} from '../../../utils/backendUtils';
import {UserContext} from '../../../utils/userDetailsProvider';

import eventBus from '../../../utils/globalPubSub';
import {getTopBid, getTopBidUser} from '../../../utils/bidHelpers';
import {sendBidToBackend} from '../../../utils/backendUtils';
import { initializeRazorpay } from "../../../utils/paymentHelpers";
import { PaymentContext } from "../../../utils/paymentConfigProvider";

import { SOCKET_URL } from "../../../constants/urls";


const ButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
`

export default function BidButtonHandler(props){
    const { username } = useParams();
    const userDetails = useContext(UserContext);
    const paymentConfig = useContext(PaymentContext);
    
    
    const socketInformation = useRef({});
    const [isOpen, setIsOpen] = useState(false);
    const [piAvailable, setPiAvailable] = useState(false);
    const [error, setError] = useState('');
    
    let highestBid = props.item.highestMintBid
    if(!highestBid){
        highestBid = 0
    }

    const isIndiaPayment = (
        paymentConfig.ipLocationCountryCode == 'IN'?true:false);
    
    let incrementFactor = 1;
    
    if(isIndiaPayment){
        incrementFactor = 1;
    }
    
    const [currBid, setCurrBid] = useState(
        Number(highestBid)+incrementFactor);

    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);
    const [user, setUser] = useState({});

    //currtop bid is different, sorry
    const [topBid, setTopBid] = useState(0);
    const [topBidUser, setTopBidUser] = useState(0);

    useEffect(()=>{
        if(getPaymentInformation()){
            console.log('piAvailable', getPaymentInformation());
            setPiAvailable(true)
        }
        else{
            console.log('piAvailable NO', getPaymentInformation());
        }
    },[]);

    useEffect(
        ()=>{
            setCurrBid(Number(highestBid)+incrementFactor)
        },
        [userDetails])

    const sendIndiaBid = async (val, topBidUser) => {
        setLoader(true);
        let resp = await sendIndiaBidToBackend(
            val, props.item.auctionId, props.item._id);
        if(!resp){
            setLoader(false);
            setError('Failed');
            setTimeout(()=>{setError('')}, 5000);
            return
        }
        if(!resp.success){
            setLoader(false);
            setError(resp.message);
            setTimeout(()=>{setError('')}, 5000);
            return;
        }
        if(resp.success){
            //eventBus.dispatch("new-bid-add");
            initializeRazorpay(
                val, resp.data.order.id,
                setError, setSuccess);
            setLoader(false);

        }
    }
    
    const sendBid = async (val, topBidUser) => {
        console.log('send bid called')
        if(isIndiaPayment){
            sendIndiaBid(val)
            return;
        }
        if(!getPaymentInformation()){
            eventBus.dispatch('open-payment-information');
            return;
        }
        setLoader(true);
        let resp = await sendBidToBackend(
            val, props.item.auctionId, props.item._id);
        
        setLoader(false);
        if(!resp){
            setError('Failed');
            window.analytics.track('bid_placed', {
                ...props.item,
                 value: currBid,
                 type: 'web',
                success: false,
                message: 'Failed'
             });
            setTimeout(()=>{setError('')}, 5000);
            return
        }
        if(!resp.success){
            setError(resp.message);
            window.analytics.track('bid_placed', {
                ...props.item,
                 value: val,
                 type: 'web',
                 success: false,
                 message: resp.message
             });
            setTimeout(()=>{setError('')}, 5000);
            return;
        }
        if(resp.success){
            eventBus.dispatch("new-bid-add");
            setSuccess(true);
            window.analytics.track('bid_placed', {
                ...props.item,
                 value: val,
                 type: 'web',
                 success: true,
             });
        }
    }
    
    const handleLogin = async (loginDetails)=>{
        setUser(loginDetails.user);        
    }

    const handleLogout = ()=> {setUser({});}

    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        });
        return () => {
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    },[]);

    const handleCustomBidClick = () => {
        if(isIndiaPayment){
            setIsOpen(true);
            return;
        }
        if(!getPaymentInformation()){
            eventBus.dispatch('open-payment-information');
        }
        else{
            setIsOpen(true);
        }
    }
    
    useEffect(()=>{
        eventBus.on('payment-details-changed', (pd)=>{
            if(pd){setPiAvailable(true)}
            else{setPiAvailable(false)}
        })
        return () => {
            eventBus.remove('payment-details-changed');
        }
    })
    

    const connectSocket = (userName)=>{        
        const socket = io(SOCKET_URL, {
            transports: ['websocket'], query: {roomId:`c-${userName}`}});
        socketInformation.current.userId = userName;
        socketInformation.current.socket = socket;
        socket.on('connect', () => {
            console.log('socket establishedgg');
            socket.on('message', (data: any) => {
                if(data.type === "onNewTopBid"){
                    console.log('onNewTopBid', data)
                    if(data.data.payload.serial===props.item.serial){
                        let topBid = Number(data.data.payload.value)
                        setCurrBid(topBid+1);
                    }
                }
            });
            socket.on('data', (data) => {
                console.log('data2', data);
            });
        });        
        socket.on('disconnect', (reason) => {
            console.log(socket.id, reason);
            console.log('disconnect gg')
            socketInformation.current.socket = undefined;
            socketInformation.current.userId = undefined;
        });
    }

    useEffect(()=>{
        connectSocket(username);
    },[]);

    useEffect(()=>{
        console.log('props.bids', props.bids);
        let topBid = getTopBid(props.bids);
        let topBidUser = getTopBidUser(props.bids, user);
        setTopBid(topBid)
        setTopBidUser(topBidUser)
    }, [props.bids, user])

    
    return (
        <>
            <Web2BidComponents
                isOpen={isOpen}
                item={props.item}
                topBid={topBid}
                topBidUser={topBidUser}
                closeModal={()=> {setIsOpen(false)}}
            >
            </Web2BidComponents>
            <>
                {(true) && (
                    <>
                        <div style={{
                            display:'flex',
                            justifyContent: 'space-between'
                        }}>
                            <div onClick={()=>{
                                if(loader){
                                    return;
                                }
                                window.analytics.track('bid_button_clicked', {
                                    ...props.item,
                                    value: currBid,
                                    type: 'web',
                                    
                                });
                                if(isIndiaPayment){
                                    sendBid(
                                        topBid-topBidUser+
                                        incrementFactor, topBidUser);
                                }
                                else{sendBid(currBid);}
                            }}
                                 style={{
                                     margin: 0,
                                     display:'flex',
                                     width: '68%',
                                     height: 51,
                                     background: 'yellow',
                                     justifyContent: 'center',
                                     alignItems: 'center',
                                     cursor: 'pointer'
                                 }}>
                                <>
                                    {(!loader) && (
                                        <>
                                            {(isIndiaPayment) && (
                                                <>
                                                    {(topBidUser!=0) && (
                                                        <ButtonTextSpan>
                                                            Out Bid with {topBid-topBidUser+incrementFactor}
                                                            <>&#8377;</>
                                                        </ButtonTextSpan>
                                                    )}
                                                    {(topBidUser==0) && (
                                                        <ButtonTextSpan>
                                                            Bid {currBid}
                                                            <>&#8377;</>
                                                        </ButtonTextSpan>
                                                    )}
                                                </>
                                                
                                            )}
                                            {(!isIndiaPayment) && (
                                                <ButtonTextSpan>
                                                    Bid {currBid}$
                                                </ButtonTextSpan>
                                            )}
                                        </>
                                    )}
                                    {(loader) && (
                                        <Bars
                                            heigth="30" width="30"
                                            color="grey"
                                            ariaLabel="loading-indicator" />
                                    )}
                                </>
                            </div>
                            <div onClick={()=>{handleCustomBidClick()} }
                                 style={{
                                     margin: 0,
                                     display:'flex',
                                     width: '29%',
                                     height: 51,
                                     background: '#FFFFFF',
                                     justifyContent: 'center',
                                     alignItems: 'center',
                                     cursor: 'pointer'
                                 }}>
                                <ButtonTextSpan>
                                    Custom
                                </ButtonTextSpan>
                            </div>
                        </div>
                    </>
                )}
            </>
        </>
    );
}
